import PopperJS from 'popper.js';
import React from 'react';

import { OnChangeHandler, SelectWidths } from './types';
import { EChildMenuDirections, useControls } from './useControls';
import { SelectContext, useSelectContext } from './useSelectContext';

export interface ISelectContextWrapper<T = any> {
  flip?: boolean;
  fixed?: boolean;
  placement?: PopperJS.Placement;
  childDirection?: EChildMenuDirections;
  selectedValue?: string;
  onChange?: OnChangeHandler<T>;
  width?: SelectWidths;
}

export const SelectContextWrapper: React.FC<ISelectContextWrapper> = (props) => {
  const parentCtx = useSelectContext();
  const context = useControls({ context: parentCtx, ...props });
  return <SelectContext.Provider value={context}>{props.children}</SelectContext.Provider>;
};
